export const CLASSES_FOCUSED = [
  '.container-card-cover',
  '.card-cover',
  '.card-talent',
  '.card',
  '.aaf-main-search-card-vod-main-image-div',
  '.aaf-vcard-button-icon',
  '.video-player-control-button',
  '.aaf_plan-selector-item-card',
  '.aaf-main-modal-options-button-seasons',
  '.aaf_main_search_content_play_main_grid_children',
  '.aaf-main-search-card-vod-main-right-button-more-info',
  '.ribbon-categories>a',
  '.aaf_app_payment-method-select-content-center-buttons>a',
  '.modal-button-months',
  '.modal-button-years',
  '.modal-button-states',
  '.modal_categorie_button_filter',
  '.channels-categories-col>a',
  '.modal-button-documents',
  '.modal-button-documents-filter',
  '.button-image',
  '.aaf_ribbon-plan-selector-item-more-info-tab',
  '.profile-avatar-image',
  '.multiple-image',
  '.image-profile'
];

export const CIRCLE_ELEMENTS = [
  '.ribbon-talent>a',
  '.user-profile>.card-container>a',
  '.video-player-control-button',
  '.aaf-main-search-card-talent-main-image-div',
  '.ribbon-talent-cm>a',
  '.profile-avatar-image',
  '.image-profile'
];

//Cards
export const ID_NAME_SUPERDESTACADOS = "highlight"
export const ID_NAME_LO_MAS_VISTO = "Carrousellomastop"
export const ID_NAME_CARD_VERTICAL = "Carrouselverticalampliado"
export const ID_NAME_CARD_PERSONAJES = "personajesfavoritos"
export const ID_NAME_CARD_TALENTS = "vcardtalentsribbon"
export const ID_NAME_PLAN_SELECTOR_ITEM = "planselectoritem-"
export const CLASS_NAME_DEFAULT_FOCUSABLE_LIST_INFINITE = "firstElementFocusableDefault"
export const CLASS_NAME_MULTI_IMAGE = "multiple-image"
export const ID_NAME_CARD_CLASSIC = "_classic_link_"
export const ID_NAME_CARD_RECORDINGS = "_recordings_link_"
export const ID_NAME_CARD_MUSIC_RIBBONS = "isCardMusic_"
export const ID_VCARD_EPISODES = "episodesvcard_"
export const ID_VCARD_RECOMENDATIONS = "vcardrecomendationribbon_"
export const ID_NAME_VCARD_OPTIONS_YELLOW = "vcardactions_0_yellowvcardaction"

export const ID_NAME_SEARCH_VERTICAL = "buscador"
export const ID_NAME_SEARCH_HORIZONTAL = "programastv"
export const ID_NAME_SEARCH_TALENTS = "talentos"

//Buttons
export const ID_NAME_SECONDLEVEL = "secondlevel-"
export const ID_NAME_PLAYER_CONTROL = "pc"
export const ID_NAME_VCARD_OPTIONS = "vcardactions_"
export const ID_MODAL_FILTER_BUTTON = "modal-filter-button-"
export const ID_NAME_SEASON_TEMP = "season_temp_"
export const ID_PROFILE_AVATAR_IMAGE = "id_profile-avatar-image"
export const ID_NAME_FILTER_LIVE_BUTTONS = "modalfilterlive_button_"
export const ID_NAME_CARD_CHANNEL_CATEGORY = "channel-category"
export const CLASS_NAME_OUTLINE_FOCUS = "outline-focus"


//Modals
export const ID_NAME_MODAL_TALENT = "modaltalent"
export const ID_NAME_FIRST_ELEMENT_MODAL_TALENT = `${ID_NAME_MODAL_TALENT}_classic_link_0`

//Excluded
export const CLASSES_EXCLUDED = [
  'link-premiumimage',
  'link-highlight',
  'link-classic'
]
//First focus
export const ID_NAME_FIRST_FOCUS_GRID_SECOND_LEVEL= "infinitysection_infinite_link"
export const STYLEFILTERBUTTON = "modal-filter-butto"
export const COLORFILTERBUTTON = "red"
export const IDYELLOWBUTTON = "id_yellow_button"



// WEBPACK FOOTER //
// ./src/components/Focus/constants.ts